import {useEventListener} from 'usehooks-ts';

import {isKeyPressed} from 'utils/utils';
import Constants from 'utils/constants';

import {type PostMenuItem, type PostMenuItems} from './types';

function isKeyboardEvent(event: KeyboardEvent) {
    return event.getModifierState !== undefined;
}

export function usePostMenuShortcuts(
    menuItems: PostMenuItems,
    isMenuOpened: boolean,
    hideMenu: () => void,
) {
    function callActionIfExist(item: PostMenuItem | null, event: KeyboardEvent) {
        if (!item) {
            return;
        }

        event.preventDefault();
        item.action(event);
        hideMenu();
    }

    const handleShortcutKeyDown = (event: KeyboardEvent): void => {
        if (!isMenuOpened || !isKeyboardEvent(event)) {
            return;
        }

        switch (true) {
        case isKeyPressed(event, Constants.KeyCodes.R):
            return callActionIfExist(menuItems.DISCUSS_MESSAGE, event);

        case isKeyPressed(event, Constants.KeyCodes.E):
            return callActionIfExist(menuItems.EDIT, event);

        case isKeyPressed(event, Constants.KeyCodes.F):
            return callActionIfExist(menuItems.POST_FOLLOW, event);

        case isKeyPressed(event, Constants.KeyCodes.K):
            return callActionIfExist(menuItems.COPY_LINK, event);

        case isKeyPressed(event, Constants.KeyCodes.C):
            return callActionIfExist(menuItems.COPY_TEXT, event);

        case isKeyPressed(event, Constants.KeyCodes.DELETE):
            return callActionIfExist(menuItems.DELETE, event);

        case isKeyPressed(event, Constants.KeyCodes.P):
            callActionIfExist(menuItems.PIN, event);
            callActionIfExist(menuItems.UNPIN, event);
            return;

        case isKeyPressed(event, Constants.KeyCodes.S):
            callActionIfExist(menuItems.SAVE, event);
            callActionIfExist(menuItems.REMOVE_FROM_SAVED, event);
            return;

        case isKeyPressed(event, Constants.KeyCodes.U):
            return callActionIfExist(menuItems.MARK_AS_UNREAD, event);
        }
    };

    useEventListener('keydown', handleShortcutKeyDown, undefined, true);
}
